import {routeToLogin} from './utils';

const AUTO_REDIRECT_MS = 5000;
let modalShown = false;

export function showSessionExpiredModal() {
  if (modalShown) return;
  modalShown = true;

  const overlay = document.createElement('div');
  overlay.id = 'session-expired-overlay';
  overlay.style.cssText = `
    position: fixed; inset: 0; background: rgba(0,0,0,0.5);
    z-index: 100000; display: flex; align-items: center; justify-content: center;
    font-family: Roboto, sans-serif;
  `;

  const modal = document.createElement('div');
  modal.style.cssText = `
    background: #fff; border-radius: 8px; padding: 24px 28px;
    max-width: 400px; width: 90%; box-shadow: 0 8px 24px rgba(0,0,0,0.2);
    text-align: center;
  `;

  const title = document.createElement('div');
  title.textContent = 'Session Expired';
  title.style.cssText = 'font-size: 18px; font-weight: 600; margin-bottom: 12px; color: #222;';

  const message = document.createElement('div');
  message.textContent = 'Your session has expired. Please log in again.';
  message.style.cssText = 'font-size: 14px; color: #555; margin-bottom: 20px; line-height: 1.5;';

  const countdown = document.createElement('div');
  countdown.style.cssText = 'font-size: 12px; color: #888; margin-bottom: 16px;';
  let seconds = Math.ceil(AUTO_REDIRECT_MS / 1000);
  countdown.textContent = `Redirecting in ${seconds}s...`;

  const btn = document.createElement('button');
  btn.textContent = 'Log in again';
  btn.style.cssText = `
    background: #1976d2; color: #fff; border: none; border-radius: 4px;
    padding: 10px 24px; font-size: 14px; font-weight: 500; cursor: pointer;
  `;

  const goToLogin = () => {
    clearInterval(tick);
    clearTimeout(redirectTimer);
    routeToLogin();
  };
  btn.addEventListener('click', goToLogin);

  modal.appendChild(title);
  modal.appendChild(message);
  modal.appendChild(countdown);
  modal.appendChild(btn);
  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  const tick = setInterval(() => {
    seconds -= 1;
    if (seconds > 0) countdown.textContent = `Redirecting in ${seconds}s...`;
  }, 1000);

  const redirectTimer = setTimeout(goToLogin, AUTO_REDIRECT_MS);
}
